<style lang="stylus">
    .pagecollect-empty-container
        min-height calc(100% - 64px)
        position relative
    .pagecollect-container
        position relative
        margin-top 60px
    .pagecollect-empty
        display flex
        justify-content center
        align-items center
        position absolute
        left 0
        right 0
        top 0
        bottom 0
        .empty-box
            display flex
            justify-content center
            flex-wrap wrap
            width 250px
            .empty-svg
                width 241px
                height 117px
            .empty-svg_viewer
                width 224px
                height 109px
            .empty-text
                font-size 14px
                color #000
                text-align center
                margin-top 20px
                a
                    color var(--themeColor)
                    &:hover,&:link,&:active,&:visited
                        text-decoration underline

    .pagecollect-page
        display flex
        justify-content space-around
        margin-top 15px
        color #626262 !important

        .el-pagination
            button
                background none !important

        .el-pager li
            background none
    .dark-theme__workbench
        .pagecollect-empty
            .empty-box
                .empty-text
                    color #fff
</style>
<template>
    <div :class="{ 'pagecollect-container': works.length > 0 && isfixed, 'pagecollect-empty-container': works.length <= 0 }">
        <div ref="con" class="page-waterfall" v-show="works.length != 0" :style="{ height: `${fitHeight}px` }">
            <waterfall ref="collect" :workType="'COLLECT'" :works="works" />
        </div>

        <div class="pagecollect-empty" v-if="!loading && works.length == 0">
            <div class="empty-box" v-if="isViewer">
                <iconSymbol class="empty-svg_viewer" name="empty_works_viewer" />
                <p class="empty-text">{{ $t("nodata") }}</p>
            </div>
            <div class="empty-box" v-else>
                <iconSymbol class="empty-svg" name="empty_works" />
                <p class="empty-text">{{ $t("nodata") }}</p>
            </div>
        </div>

        <div class="pagecollect-page" v-show="works.length > 0 && collectTotal > pageCount">
            <Page :total="collectTotal" :page-size="pageCount" @on-change="pageChanged" size="small" />
        </div>
    </div>
</template>
<script>
    import waterfall from "./mixins/waterfall.js";
    // import { Pagination } from "element-ui";
    export default {
        name: "PageCollect",
        data() {
            return {
                works: [],
                waterfallType: "collect",
                fitHeight: 0,
            };
        },
        mixins: [waterfall],
        components: {
            // Pagination,
        },
        props: {
            isfixed: {
                type: Boolean,
                require: false,
                default: false,
            },
        },
        computed: {
            isViewer() {
                return this.$store.state.userInfo.user_id != this.$store.state.userPage.viewerID;
            },
            pageCount() {
                return this.$store.state.userPage.pageCount;
            },
            collectTotal() {
                return this.$store.state.userPage.collectTotal;
            },
            collectCurrent() {
                return this.$store.state.userPage.collectCurrent;
            },
        },
        methods: {
            toTop() {
                let targetDom = document.children[0];
                targetDom.scroll = (e) => {
                    e.preventDefault();
                };
                const scrollToTop = () => {
                    const scrollTop = targetDom.scrollTop;
                    if (scrollTop > 0) {
                        window["scrollTopID"] = window.requestAnimationFrame(scrollToTop);
                        targetDom.scrollTo(0, scrollTop - scrollTop / 8);
                    } else {
                        window.cancelAnimationFrame(window["scrollTopID"]);
                        window["scrollTopID"] = null;
                        targetDom.scroll = null;
                    }
                };
                window["scrollTopID"] = window.requestAnimationFrame(scrollToTop);
            },
            pageChanged(page) {
                this.works = [];
                this.$store.dispatch("userPage/getIntervieweeCollectByPage", page).then((e) => {
                    this.works = this.$store.state.userPage.collectWorks;
                    this.updateWaterfall({ works: this.works });
                });
                this.toTop();
            },
            reloadPage() {
                this.works = this.$store.state.userPage.collectWorks;
                this.updateWaterfall({ works: this.works });
                this.toTop();
            },
            resizeFit() {
                const topBar = 60;
                const menu = 64;
                const margin = 24;
                const pager = 24;
                let winH = window.innerHeight;
                this.fitHeight = winH - topBar - menu - margin - pager - margin;
            },
        },
        created() {
            this.$bus.$on("reloadCollect", () => {
                this.reloadPage();
            });
            this.works = this.$store.state.userPage.collectWorks;

            this.resizeFit();
            window.addEventListener("resize", this.resizeFit);
        },
        beforeDestroy() {
            this.$bus.$off("reloadCollect");
            window.removeEventListener("resize", this.resizeFit);
        },
    };
</script>
<i18n>
{
  "zh": {
    "nodata": "这里什么都没有哦"
  },
  "en": {
    "nodata": "It is empty"
  },
  "kr": {
    "nodata": "아직 아무 작업도 없네요~"
  },
  "tw": {
    "nodata": "這裡什麼都沒有哦"
  },
  "jp": {
    "nodata": "空です"
  },
  "id": {
    "nodata": "Kosong"
  }
}
</i18n>
